export function scrollToCampaign(campaignName: string) {
    // Find the matching item using data attribute
    const targetItem = document.querySelector(`.item[data-campaign="${campaignName}"]`);

    if (targetItem) {
        let scrollOffset = 0;
        let scrollTarget: Element | null = null;

        // Check if item is inside swiper-container
        const swiperContainer = targetItem.closest('.swiper');

        if (swiperContainer) {
            // If in swiper, get parent .genre
            scrollTarget = targetItem.closest('.genre');

            if (scrollTarget) {
                // Access swiper instance
                const swiper = (swiperContainer as any).swiper;
                const targetSlide = targetItem.closest('.swiper-slide');

                if (swiper && targetSlide) {
                    const slideIndex = Array.from(targetSlide.parentElement?.children || []).indexOf(targetSlide);
                    swiper.slideTo(slideIndex);
                }

                // Adjust scroll offset for swiper items
                const targetRect = scrollTarget.getBoundingClientRect();
                if (window.innerWidth < 991) {
                    scrollOffset = window.scrollY + targetRect.top - 55;
                } else {
                    scrollOffset = window.scrollY + targetRect.top - 73;
                }
            }
        } else if (targetItem.closest('.plan-wrapper')) {
            // If in plan-wrapper, scroll to the item itself
            scrollTarget = targetItem;

            // Adjust scroll offset for plan wrapper items
            const targetRect = scrollTarget.getBoundingClientRect();
            if (window.innerWidth < 991) {
                scrollOffset = window.scrollY + targetRect.top - 70;
            } else {
                scrollOffset = window.scrollY + targetRect.top - 100;
            }
        }

        // Smooth scroll to the adjusted position
        window.scrollTo({
            top: scrollOffset,
            behavior: 'smooth'
        });

        // Add active class to card
        const card = targetItem.querySelector('.card');
        if (card) {
            card.classList.add('active');

            // Remove active class after 600ms
            setTimeout(() => {
                card.classList.remove('active');
            }, 600);
        }
    } else {
        console.log('No item found for campaign:', campaignName);
    }
}